import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { calculateYearsAndMonths, formattedDate, isGivenDateInCurrentYear, renderPrintFooter } from "../../utils";
import { ApolloConsumer } from '@apollo/client';
import { fetchData } from '../Service/graphQlService';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import SplitButton from '../SplitButton/SplitButton';

const limit = 50;
const rosterColumns = [
    {
        code: 'IS_AGENT',
        name: 'Role',
        render: (el) => {
            if (el.is_agent === "y") return "Agent";
            if (el.is_agent === "h") return "AthCap - Agent";
            if (el.is_agent === "e") return "AthCap - Employee";
            if (el.is_agent === "i") return "Intern";
            return "Employee";
        }
 },
    {
        code: 'FIRST_NAME',
        name: 'Name',
        columnStyle: {
            minWidth: 150
        },
        render: (el) => el.first_name+" "+el.last_name,
    },
    {
        code: 'ADDRESS',
        name: 'Address',
        columnStyle: {
            minWidth: 230
        },
        render: (el) => el.address,
    },
    {
        code: 'CITY',
        name: 'City',
        render: (el) => el.city,
    },
    {
        code: 'STATE',
        name: 'State',
        render: (el) => el.state,
        className: 'paddingLeft'
    },
    {
        code: 'ZIP',
        name: 'ZIP',
        columnStyle: {
            minWidth: 80
        },
        render: (el) => el.zip,
    },
    {
        code: 'YRS_AT_STRIVE',
        name: 'Years At Strive',
        render: (el) => el.starting_date ? calculateYearsAndMonths(new Date(el.starting_date)) : '',
        className: 'paddingLeft55'
    },
    {
        code: 'STARTING_DATE',
        name: 'Start Date',
        render: (el) => el.starting_date ? formattedDate(el.starting_date):'',
    },
];


const callListColumns = [
    {
        code: 'IS_AGENT',
        name: 'Role',
        render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":el.is_agent==="i"?"Intern":"Employee",
    },
    {
        code: 'FIRST_NAME',
        name: 'Name',
        columnStyle: {
            minWidth: 150
        },
        render: (el) => el.first_name+" "+el.last_name,
    },
    {
        code: 'PHONE',
        name: 'Work Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.phone,
    },
    {
        code: 'CELL_PHONE',
        name: 'Cell Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.cell_phone,
    },
    {
        code: 'BIRTH_DATE',
        name: 'Birth Date',
        render: (el) => el.birth_date ? formattedDate(el.birth_date):'',
    }
];


const listingColumn = [
    {
        code: 'FIRST_NAME',
        name: 'Name',
        columnStyle: {
            minWidth: 150
        },
        render: (el) => el.first_name+" "+el.last_name,
    },
    {
        code: 'ON_PHONES',
        name: 'On Phones',
        render: (el) =>  el.on_phones && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool)) ? formattedDate(el.on_phones):'',
    },
    /*{
        code: 'IN_POOL',
        name: 'In Pools',                
        render: (el) => el.in_pool && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool))?formattedDate(el.in_pool):'',
    },*/
    {
        code: 'FIRST_LISTING',
        name: '1st Listing',
        render: (el) => el.first_listing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h")  ? formattedDate(el.first_listing):'',
    },
    {
        code: 'FIRST_CLOSING',
        name: '1st Closing',
        render: (el) => el.first_closing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h") ? formattedDate(el.first_closing):'',
    }
];
const columns = [
    {
        name: '',
        textAlign: 'center',
        columnStyle: {width: 70},
        // render: (el) => (
        //     <Link to={{ pathname: `${arc.path.base}teamMember/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
        // ),
        render: (el) => {
            const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
            const currentSearch = window.location.search;
            const currentPath = window.location.pathname + currentSearch;
          
            return (
              <Link to={{
                pathname: `${basePath}/teamMember/${el.contact_id}`,
                state: { fromListUrl: currentPath }
              }}>
                <Icon svg={svgEdit} />
              </Link>
            );
          }
    },
    {
        code: 'IS_AGENT',
        name: 'Role',
        render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":el.is_agent==="i"?"Intern":"Employee",
    },
    {
        code: 'FIRST_NAME',
        name: 'Name',
        columnStyle: {
            minWidth: 150
        },
        render: (el) => el.first_name+" "+el.last_name,
    },
    {
        code: 'PHONE',
        name: 'Work Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.phone,
    },

    {
        code: 'CELL_PHONE',
        name: 'Cell Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.cell_phone,
    },
    {
        code: 'STARTING_DATE',
        name: 'Start Date',
        render: (el) => el.starting_date ? formattedDate(el.starting_date):'',
    },
    {
        code: 'YRS_AT_STRIVE',
        name: 'Years At Strive',
        textAlign: 'center',
        render: (el) => el.starting_date ? calculateYearsAndMonths(new Date(el.starting_date)) : '',
    },
    {
        code: 'BIRTH_DATE',
        name: 'Birth Date',
        render: (el) => el.birth_date ? formattedDate(el.birth_date):'',
    },
    {
        code: 'ON_PHONES',
        name: 'On Phones',
        render: (el) =>  el.on_phones && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool)) ? formattedDate(el.on_phones):'',
    },
    /*{
        code: 'IN_POOL',
        name: 'In Pools',                
        render: (el) => el.in_pool && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool))?formattedDate(el.in_pool):'',
    },*/
    {
        code: 'FIRST_LISTING',
        name: '1st Listing',
        render: (el) => el.first_listing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h")  ? formattedDate(el.first_listing):'',
    },
    {
        code: 'FIRST_CLOSING',
        name: '1st Closing',
        render: (el) => el.first_closing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h") ? formattedDate(el.first_closing):'',
    },
    {
        code: 'ADDRESS',
        name: 'Address',
        columnStyle: {
            minWidth: 230
        },
        render: (el) => el.address,
    },
    {
        code: 'CITY',
        name: 'City',
        render: (el) => el.city,
    },
    {
        code: 'STATE',
        name: 'State',
        render: (el) => el.state,
        className: 'textCenter'
    },
    {
        code: 'ZIP',
        name: 'ZIP',
        columnStyle: {
            minWidth: 80
        },
        render: (el) => el.zip,
    }
];
export default class TeamMemberList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            original: [],
            totalCount: null,
            error: null,
            isBusy: null, 
            printType: 'All Fields',
            printColumns: columns,
            width: 0,
        };
        this.client = null
        this.handleDropdownChange = this.handleDropdownChange.bind(this)
        this.renderPrintPage = this.renderPrintPage.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
            this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      updateWindowDimensions() {
        this.setState({ width: window.innerWidth });
      }
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }

    fetch(q) {
        this.setState({ isBusy: true });

        const query = { ...q };
        const options = filter(query, 'team-member');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize:limit
        }
        
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 

        if (this.client) {
            fetchData(GET_CONTACT_TEAM_LIST_QUERY, {type:"Team", filters:filterOptions, sortOptions: sortOptions})
                .then(res => {
                    this.setState({
                        items: res.data.getContacts.data,
                        totalCount: res.data.getContacts.totalCount,
                        original: res.data.getContacts.data,
                        error: null,
                        isBusy: null,
                    });
                })
                .catch(err => {
                    this.setState({
                        error: err.message,
                        isBusy: null,
                    });
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }
    handleDropdownChange(option){
        switch (option) {
            case 'Roster':
                this.setState({
                    printType: 'Roster',
                    printColumns: rosterColumns,
                    items: [...this.state.original],
                    totalCount: this.state.original.length,
                })
                break;
            case 'Call List':
                this.setState({
                    printType: 'Call List',
                    printColumns: callListColumns,
                    items: [...this.state.original],
                    totalCount: this.state.original.length,
                })
                break;
            case '1st Listing & 1st Closing':
                const agentsList = this.state.original.filter(item => item.is_agent === 'y')
                this.setState({
                    printType: '1st Listing & 1st Closing',
                    printColumns: listingColumn,
                    items: agentsList,
                    totalCount: agentsList.length,
                })
                break;
            case 'All Fields':
                this.setState({
                    printType:  'All Fields',
                    printColumns: columns,
                    items: [...this.state.original],
                    totalCount: this.state.original.length,
                })
                break;
        }
    }

    renderPrintPage() {
        // const splitObjectIntoChunks = (entries, chunkSize = 8) => {
        //     return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
        //      entries.slice(i * chunkSize, (i + 1) * chunkSize)
        //     );
        //   };
        const splitObjectIntoChunks = (entries, chunkSize = 8) => {
            if (!Array.isArray(entries)) return [];
          
            return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
              entries.slice(i * chunkSize, (i + 1) * chunkSize)
            );
          };
        // Split rows into chunks
        const rowChunks = splitObjectIntoChunks(this.state.items);
        return (
            <React.Fragment>
            {rowChunks.map((rowChunk, chunkIndex) => (
                    <div className='print-container'  key={chunkIndex} style={{background: `url('${arc.path.media+'Transaction_Background.png'}')`}} >
                        {chunkIndex === 0 && <div className='TeamMemberList_head_left'>
                            <h3 className='TeamMemberList_h3'>Team Members - {this.state.items.length}</h3>
                        </div>}
                        <div className={`table-print-container ${chunkIndex !== 0 && 'marginTop50'}`}>
                            <SortTable columns={this.state.printColumns}
                                    items={rowChunk}
                                    query={this.props.location.query}
                            />
                        </div>
                        {renderPrintFooter(true)}
                    </div>
           
             ))}
              </React.Fragment>
        )
    }
    render() {
        const query = this.props.location.query;

//         const columns = [
//             {
//                 name: '',
//                 textAlign: 'center',
//                 columnStyle: { width: 70 },
//                 render: (el) => (
//                     <Link to={{ pathname: `${arc.path.base}teamMember/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
//                 ),
//             },
//             {
//                 code: 'IS_AGENT',
//                 name: 'Role',
//                 render: (el) => el.is_agent && el.is_agent === "y" ? "Agent" : el.is_agent === "h" ? "HSC" : "Employee",
//             },
//             {
//                 code: 'FIRST_NAME',
//                 name: 'Name',
//                 columnStyle: {
//                     minWidth: 150
//                 },
//                 render: (el) => el.first_name + " " + el.last_name,
//             },
//             {
//                 code: 'PHONE',
//                 name: 'Work Phone',
//                 columnStyle: {
//                     minWidth: 120
//                 },
//                 render: (el) => el.phone,
//             },

//             {
//                 code: 'CELL_PHONE',
//                 name: 'Cell Phone',
//                 columnStyle: {
//                     minWidth: 120
//                 },
//                 render: (el) => el.cell_phone,
//             },
//             {
//                 code: 'STARTING_DATE',
//                 name: 'Start Date',
//                 render: (el) => el.starting_date ? formattedDate(el.starting_date) : '',
//             },
//             {
//                 code: 'YRS_AT_STRIVE',
//                 name: 'Years At Strive',
//                 textAlign: 'center',
//                 render: (el) => el.starting_date ?calculateYearsAndMonths(new Date(el.starting_date)):'',
//             },
//             {
//                 code: 'BIRTH_DATE',
//                 name: 'Birth Date',
//                 render: (el) => el.birth_date ? formattedDate(el.birth_date) : '',
//             },
//           {
//     code: 'ON_PHONES',
//     name: 'On Phones',
//     render: (el) => {
//         const inPoolDate = el.in_pool ? formattedDate(el.in_pool) : null;
//         const onPhonesDate = el.on_phones ? formattedDate(el.on_phones) : null;

//         return el.on_phones && el.is_agent && 
//                (el.is_agent === "y" || el.is_agent === 'h') && 
//                inPoolDate && isGivenDateInCurrentYear(inPoolDate) ? onPhonesDate : '';
//     },
// },
// {
//     code: 'IN_POOL',
//     name: 'In Pools',
//     render: (el) => {
//         const inPoolDate = el.in_pool ? formattedDate(el.in_pool) : null;

//         return el.in_pool && el.is_agent && 
//                (el.is_agent === "y" || el.is_agent === 'h') && 
//                inPoolDate && isGivenDateInCurrentYear(inPoolDate) ? inPoolDate : '';
//     },
// },
//             {
//                 code: 'FIRST_LISTING',
//                 name: '1st Listing',
//                 render: (el) => el.first_listing && el.is_agent && (el.is_agent === "y" || el.is_agent === "h") ? formattedDate(el.first_listing) : '',
//             },
//             {
//                 code: 'FIRST_CLOSING',
//                 name: '1st Closing',
//                 render: (el) => el.first_closing && el.is_agent && (el.is_agent === "y" || el.is_agent === "h") ? formattedDate(el.first_closing) : '',
//             },
//             {
//                 code: 'ADDRESS',
//                 name: 'Address',
//                 columnStyle: {
//                     minWidth: 230
//                 },
//                 render: (el) => el.address,
//             },
//             {
//                 code: 'State',
//                 name: 'State',
//                 render: (el) => el.state,
//             },
//             {
//                 code: 'CITY',
//                 name: 'City',
//                 render: (el) => el.city,
//             },
//             {
//                 code: 'ZIP',
//                 name: 'ZIP',
//                 columnStyle: {
//                     minWidth: 80
//                 },
//                 render: (el) => el.zip,
//             }
//         ];
        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                        this.fetch(this.props.location.query);
                    }
                    return (
                        <div className='TeamMemberList' data-is-busy={this.state.isBusy}>
                            {this.renderPrintPage()}
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Team Members</div>
                                        {/* <LinkComp to={`${arc.path.base}teamMember`}> */}
                                        <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}teamMember`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                        <div style={{ display: 'flex', justifyContent: 'end', width: this.state.width - 466 }}>
                                            <SplitButton icon={this.state.printType === 'All Fields' ? false : true} options={['All Fields', 'Roster', 'Call List', '1st Listing & 1st Closing']} onChange={this.handleDropdownChange} selectedOption={this.state.printType} onClick={() => this.state.printType !== 'All Fields' && window.print()} />
                                        </div>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={this.state.printColumns}
                                    items={this.state.items}
                                    query={query}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}
